import 'react-tabulator/lib/styles.css';
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import '../../resources/css/site/SiteList.scss';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ReactTabulator, reactFormatter  } from 'react-tabulator';
import { doSelectSite, loadSiteSummary, SAVE_ORGANIZATION_DATA_SUCCESS } from '../../actions/site/index';
import ListColumnBtn from '../common/ListColumnBtn';
import ModalSiteDetail from './ModalSiteDetail';
import { popupModalConfirm, openModal, closeModal, openModalAlert } from '../../actions/index';
import { doActivePage } from '../../actions/menu/index';
import { doChangeTimeZoneId } from '../../actions/login';
import { saveModelOrgGroupDetailData, filterOrgAction, getModelOrgDetail, loadGroupList } from '../../actions/model/index';
import { doGetNotify } from '../../actions/account';
import moment from 'moment';

let componentProps = null;
let orgFilter = null;

const GroupBtnsMenu = (props) => {
  return (
    <div className='group-buttons-menu'>
      <span className='operation-button-area'>
        <span className='btn-area'><span className='icon-btn-info-n' onClick={(event) => { event.stopPropagation(event); viewRow(props);}} /></span>
        {/* <span className='btn-area'><span className='icon-btn-edit' onClick={(event) => { event.stopPropagation(event); editRow(props);}} /></span>
        <span className='btn-area'><span className='icon-btn-delete-n' onClick={(event) => { event.stopPropagation(event); deleteRow(props);}} /></span> */}
      </span>
    </div>
  );
};

const viewRow = (props) => {
  let data = props.cell._cell.row.data;

  if (componentProps) {
    const { getModelOrgDetail, openModal, doChangeTimeZoneId } = componentProps;
    openModal("modelOrganization", 'view', null, () => {doChangeTimeZoneId(data.timezone); getModelOrgDetail(data);});
  }
}


const customListDateFormat = (cell, formatterParams, onRendered) => {
  const timezone = cell.getRow().getData().timezone ? cell.getRow().getData().timezone : "Asia/Taipei";
  const dateFormat = formatterParams['dateFormat'] ? formatterParams['dateFormat'] : "YYYY-MM-DD HH:mm:ss";
  return cell.getValue() ? moment.utc(cell.getValue().slice(0,19)).tz(timezone).format(dateFormat) : "";
}

class SiteList extends Component {

  tableId = 'SiteList'
  refFilterSearch = null
  refListCommonFooter = null
  // set this state for re-fresh sub component
  state = {
    refTable: null,
    deviceUsage: null,
    userUsage: null,
    isInitComplete: false,
    status: 'DO_RELOAD',

    /**
     *  visibleColumnsConfig is array
     *  title is menu tile
     *  columns is all changed visible columns for table list to display
     */
    visibleColumnsConfig: {
      title: 'Site columns',
      columns: [
        { name:'id', title: "ID", field: "id", visible: false },
        { name:'name', title: "Name", field: "name" },
        { name:'description', title: "Description", field: "description" },
        { name:'devices', title: "Devices", field: "devices" },
        { name:'clients', title: "Clients", field: "clients" },
        { name:'address', title: "Address", field: "address" },
        { name:'email', title: "Email", field: "email" },
        { name: "tel", title: "Tel.", field: "tel" },        
        { name:'country', title: "Country", field: "country" },
        { name:'state', title: "State", field: "state" },
        { name:'city', title: "City", field: "city" },
        { name:'timezone', title: "Timezone", field: "timezone" }, 
        { name:'createdDate', title: "Created Date", field: "createdDate" },
        { name:'createdBy', title: "Created By", field: "createdBy" },
        { name:'lastUpdatedDate', title: "Last Updated Date", field: "lastUpdatedDate" },
        { name:'lastUpdatedBy', title: "Last Updated By", field: "lastUpdatedBy" },
        { name:'buttonGroup', title: "buttonGroup", field: "buttonGroup", visible: false }
      ]
    },

    sessionKey: window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT['manager']
  }

  /**
   *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter
   *  
   ***/

  columns = [
    { title: "ID", field: "id", headerFilter: 'input', visible: false },
    { title: "Name", field: "name", headerFilter: 'input' },
    { title: "Description", field: "description" },
    { title: "Devices", field: "devices" },
    { title: "Clients", field: "clients" },
    { title: "Address", field: "address", visible: false },
    { title: "Tel.", field: "tel" },
    { title: "Email", field: "email" },
    { title: "Country", field: "country", headerFilter: 'input', visible: false  },
    { title: "State", field: "state", headerFilter: 'input', visible: false  },
    { title: "City", field: "city", headerFilter: 'input'  },
    { title: "Timezone", field: "timezone", headerFilter: 'input' },
    { title: "Created Date", field: "createdDate", visible: false, formatter: customListDateFormat },
    { title: "Created By", field: "createdBy", visible: false },
    { title: "Last Updated Date", field: "lastUpdatedDate", visible: false, formatter: customListDateFormat },
    { title: "Last Updated By", field: "lastUpdatedBy", visible: false },
    { title: "", field: "buttonGroup", width: 50, headerSort: false, formatter: reactFormatter(<GroupBtnsMenu />) }
  ];

  dataLoading = (datas) => {
    if (this.ref && !this.state.isInitComplete) {
      if (!componentProps) {
        componentProps = this.props;
      }
      
      // save into state
      this.setState({
        isInitComplete: true,
        refTable: this.ref.table
      });
    }
  }

  selectSite = (siteSeq) => {
    const { doSelectSite, authToken, loadGroupList } = this.props;
    // doChangeTimeZoneId(item.timezone); do at row check already
    doSelectSite(siteSeq);
    // doGetNotify(siteSeq, authToken);
    loadGroupList(authToken, siteSeq ? siteSeq : -1);
  }

  renderTable = () => {
    const { tabulatorDivHeight, authToken, doChangeTimeZoneId } = this.props;

    const options = {
      height: tabulatorDivHeight,
      pagination: "local",
      layout: "fitColumns",
      paginationDataReceived: {
        last_page: "totalPages"
      },
      paginationSize: 10, //optional parameter to request a certain number of rows per page 
      paginationSizeSelector: true,
      ajaxURL: window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["site"] + "/getsummary",
      ajaxConfig: {
        method: 'POST',
        mode: 'cors'
      },
      tableBuilt: function () {
        const container = document.querySelector('.custom-tabulator');

        if (container) {
          const paginationElement = container.querySelector('.tabulator-paginator');

          if (paginationElement) {
            paginationElement.setAttribute('id', 'site-list-pagination');

            const pageSizeSelect = paginationElement.querySelector('select');
            if (pageSizeSelect) {
              pageSizeSelect.setAttribute('id', 'site-list-selections');
            }
          }

          const buttons = paginationElement.querySelectorAll('button');
          buttons.forEach(button => {
            switch (button.textContent.trim()) {
              case 'First':
                button.setAttribute('id', 'site-list-pagination-first-btn');
                break;
              case 'Prev':
                button.setAttribute('id', 'site-list-pagination-prev-btn');
                break;
              case 'Next':
                button.setAttribute('id', 'site-list-pagination-next-btn');
                break;
              case 'Last':
                button.setAttribute('id', 'site-list-pagination-last-btn');
                break;
              default:
                break;
            }
          })
        }
      },
      ajaxContentType: {
        headers: {
          'Authorization': authToken,
          'Content-Type': 'application/json',
        },
        body: function (url, config, params) {
          //url - the url of the request
          //config - the fetch config object
          //params - the request parameters  
          return JSON.stringify({
            page: params.page,
            size: params.size,
            filterData: orgFilter
          });
        },
      },
      ajaxResponse: (url, params, response) => {
        // response.data = response.userList;
        return response.siteSummaryList; //return the response data to tabulator
      },
      ajaxError: (error) => {
        console.info(this.tableId + ' ajaxError');
      }
    };

    return (
      <ReactTabulator
        ref={(ref) => (this.ref = ref)}
        columns={this.columns}
        data={[]}
        placeholder="No data found"
        options={options}
        className="custom-tabulator"  //custom-list-table
        dataLoading={this.dataLoading}
        height={560}
        rowClick={
          (e, row) => {
            doChangeTimeZoneId(row._row.data.timezone);
            this.selectSite(row._row.data.id);
          }
        }
      />
    );
  }

  reloadList = () => {
    const { refTable } = this.state;
    if (refTable) {
      // let nowPage = refTable.getPage();
      refTable.clearData();
      // refTable.modules.page.reset(true, true);
      refTable.replaceData();      
      // if (nowPage) {
      //   refTable.setPage(nowPage);
      // }
    }
  }  

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { menuMode/*, tabulatorDivHeight*/, status } = this.props;
    const { refTable } = this.state;

    if (refTable) {
      if (prevProps.menuMode !== menuMode) {
        // if menu chagne size(mode), need redraw table     
        refTable.redraw(true);
      }
      // refTable.setHeight(tabulatorDivHeight)
    }

    if (prevProps.status !== status) {
      if (status === SAVE_ORGANIZATION_DATA_SUCCESS) {
        this.reloadList();
      }
    }
  }

  componentDidMount() {
    const { orgColumnsConfig, selectSite } = this.props;
    
    if (orgColumnsConfig) {
      this.setVisibleConfigColumnsState()
      this.setDefaultColumnsState()
    }
    orgFilter = selectSite;
  }

  render() {
    const { visibleColumnsConfig } = this.state;
    return (
      <div className='area-site-list'>
        <Row className='area-list-btn'>
          {/* <span className='area-add-icon' onClick={addRow}><span className="icon-btn-add-n"></span>Add new site </span> */}
          <span className='area-setting-list-icon'>
            <ListColumnBtn tableId={this.tableId}
                            refTable={this.state.refTable} 
                            refs={(ref) => {this.refTableToolBar = ref;}}
                            visibleColumnsConfig={visibleColumnsConfig}>
            </ListColumnBtn>
          </span>
        </Row>
        <Row className='custom-list-table-area'>
          {this.renderTable()}
          <ModalSiteDetail></ModalSiteDetail>
        </Row>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    authToken: state.loginReducers.authToken,
    accountInfo: state.loginReducers.accountInfo,
    menuMode: state.menuReducers.displayMode,
    accountRole: state.loginReducers.accountRole,
    status: state.siteReducers.status,
    timeZoneID: state.loginReducers.timeZoneID
  }
}

const mapDispatchToProps = {
  doActivePage,
  openModal,
  closeModal,
  getModelOrgDetail,
  popupModalConfirm,
  saveModelOrgGroupDetailData,
  openModalAlert,
  doSelectSite,
  filterOrgAction,
  doChangeTimeZoneId,
  loadSiteSummary,
  doGetNotify,
  loadGroupList
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
  // { doSelectSite }
)(SiteList))
